export default "__VITE_ASSET__c6ee8e9d__"